"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const CaloriesBudgetTable_1 = require("./CaloriesBudgetTable");
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const with_collapse_1 = require("../../molecules/with-collapse");
const NoBudget = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(NoBudgetWrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("memberDetailsTranslations.calorieBudget.generalTitle") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { "data-testid": "noCalorieBudgetInfo", children: t("memberDetailsTranslations.calorieBudget.noBudgetInfo") }, void 0)] }, void 0));
};
const NoBudgetWrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: ${({ theme }) => `1px solid ${theme.colors.silverBase}`};
  border-radius: ${({ theme }) => theme.utils.radius};
  margin-bottom: ${({ theme }) => theme.spacings.m};
  padding: ${({ theme }) => theme.spacings.m};
  width: 100%;

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    margin: 0;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    border-left: none;
    border-radius: 0;
    border-right: none;
  }
`;
exports.default = ({ nutritionFacts, noCalorieBudget, foodMethod, unitOfMeasure, isSecured, isCalorieBudgetExpanded, className, onIsSecureChange, onFactsChange, onCalorieBudgetSave }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    if (noCalorieBudget) {
        return (0, jsx_runtime_1.jsx)(NoBudget, {}, void 0);
    }
    if (foodMethod === "handpalm")
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0);
    const onChangeBudget = (budgetIndex) => (budget, directBudgetUpdate) => onFactsChange(budget, budgetIndex, directBudgetUpdate);
    const onSubmitBudget = (budgetIndex) => () => onCalorieBudgetSave(budgetIndex);
    return ((0, jsx_runtime_1.jsx)(WithCollapseStyled, { header: (0, jsx_runtime_1.jsx)(Header, { children: t("nutrition.progressBox.changeCalorieBudget") }, void 0), body: (0, jsx_runtime_1.jsx)(Wrapper, { children: nutritionFacts.map((facts, budgetIndex) => {
                return ((0, jsx_runtime_1.jsx)(CaloriesBudgetTable_1.CaloriesBudgetTable, { nutritionValues: facts, onChange: onChangeBudget(budgetIndex), onSubmitCalorieBudget: onSubmitBudget(budgetIndex), unitOfMeasure: unitOfMeasure, isSecured: isSecured, onIsSecureChange: onIsSecureChange, isForTrainingDay: budgetIndex > 0, isLastCaloriesBudget: budgetIndex === nutritionFacts.length - 1 }, `nutritionValueEntry_${budgetIndex}`));
            }) }, void 0), className: className, isOpen: isCalorieBudgetExpanded }, void 0));
};
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  & > div {
    flex: 1;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: 0;
  }
`;
const Header = (0, styled_components_1.default)(typography_1.H2) `
  font-weight: bold;
  margin-bottom: 0;
`;
const WithCollapseStyled = (0, styled_components_1.default)(with_collapse_1.WithCollapse) `
  margin-bottom: ${({ theme }) => theme.spacings.xs};

  & > div:last-of-type {
    padding-right: ${({ theme }) => `${theme.spacings.m}`};
  }
`;
//# sourceMappingURL=index.js.map